import { ColorTheme, ColorToken } from 'styles/colorThemes/colorThemeTypes';

export const darkTheme: ColorTheme = {
  [ColorToken.primary]: '#b9b9b9',
  [ColorToken.secondary]: '#151418',
  [ColorToken.greyPrimary]: '#1e1e21',
  [ColorToken.greySecondary]: '#ccc',
  [ColorToken.interactiveHiglightInactive]: 'rgba(207, 207, 207, 0)',
  [ColorToken.interactiveHiglightHover]: 'rgba(207, 207, 207, 0.8)',
  [ColorToken.interactiveHiglightActive]: 'rgba(207, 207, 207, 1)',

  // brinkbit design theme
  [ColorToken.brinkbitBlue]: '#60aecc',
  [ColorToken.brinkbitPrimary]: '#a6e4ff',
  [ColorToken.brinkbitSecondary]: '#050f17',
  [ColorToken.brinkbitGreyPrimary]: '#050f17',
  [ColorToken.brinkbitGreySecondary]: '#132a40',

  // spark design theme
  [ColorToken.sparkPrimary]: '#bbcbd4',
  [ColorToken.sparkSecondary]: '#e3e8ea',
  [ColorToken.sparkGreyPrimary]: '#6e8592',
  [ColorToken.sparkGreySecondary]: '#040708',
  [ColorToken.sparkGreyTertiary]: '#000',
  [ColorToken.sparkGradient1]: '#e08e26',
  [ColorToken.sparkGradient2]: '#b84a21',
  [ColorToken.sparkGradient3]: '#c25823',
  [ColorToken.sparkGradient4]: '#bb4d1e',
  [ColorToken.sparkGradient5]: '#a82f11',
  [ColorToken.sparkGradient6]: '#941103',
  [ColorToken.sparkGradient7]: '#731001',
  [ColorToken.sparkGradient8]: '#9e1708',
  [ColorToken.sparkGreyGradient1]: '#a8a8a8',
  [ColorToken.sparkGreyGradient2]: '#666',
  [ColorToken.sparkGreyGradient3]: '#828282',
  [ColorToken.sparkGreyGradient4]: '#777',
  [ColorToken.sparkGreyGradient5]: '#595959',
  [ColorToken.sparkGreyGradient6]: '#363636',
  [ColorToken.sparkGreyGradient7]: '#474747',
  [ColorToken.sparkGreyGradient8]: '#707070',
  [ColorToken.sparkMonoOrange]: '#bc4729',
  [ColorToken.sparkMonoOrangeDesaturated]: '#bcbcbc',
  [ColorToken.sparkMonoRed]: '#9a3322',
  [ColorToken.sparkMonoRedDesaturated]: '#9a9a9a',
  [ColorToken.sparkMonoYellow]: '#d2892d',
  [ColorToken.sparkMonoYellowDesaturated]: '#d2d2d2',

  // hitchd design theme
  [ColorToken.hitchdPink]: '#fe5e73',
  [ColorToken.hitchdOrange]: '#ff8d73',
  [ColorToken.hitchedLargeColorFill]: '#ef3c54',
  [ColorToken.hitchdSecondary]: '#efd4d4',
  [ColorToken.hitchdPinkDesaturated]: '#c4c4c4',
  [ColorToken.hitchdGreyPrimary]: '#231b1c',
};
